import React from "react";
import GetLinks from "Constant/Header/Header";
import { Link } from "react-router-dom";

const Navigation = () => {
  const links = GetLinks();
  return (
    <div className="grid grid-cols-1 gap-y-6 md:grid-cols-2   justify-between col-span-2 text-white capitalize text-lg">
      <div className="flex flex-col gap-y-1">
        <p className="font-bold text-xl uppercase">Quick Links</p>
        <ul className="flex flex-col gap-y-1 mt-2">
          {links.map(
            ({ name, mega, path }, index) =>
              !mega && (
                <Link
                  to={path}
                  className="hover:underline text-[#eee]"
                  key={index}
                >
                  {name}
                </Link>
              )
          )}
        </ul>
      </div>

      <div className="flex flex-col gap-y-1">
        {links?.map(
          ({ name, mega, pages }, index) =>
            mega && (
              <div key={index} className="mb-6">
                <p className="font-bold text-xl uppercase">{name}</p>
                <ul className="flex flex-col gap-y-1 mt-2">
                  {pages?.map(({ name, slug }, index) => (
                    <Link
                      key={index}
                      to={slug}
                      className="hover:underline text-[#eee]"
                    >
                      {name}
                    </Link>
                  ))}
                </ul>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default Navigation;
